import { useStore } from 'vuex';

export default () => {
  const store = useStore();

  let currentTime = new Date();

  if (store.state.isTest) {
    currentTime = store.state.testDate;
  }

  const utcTimeEpoch = Math.floor(currentTime.getTime() / 1000);

  const hasStarted = utcTimeEpoch >= process.env.VUE_APP_START_DATETIME_EPOCH;
  const hasEnded = utcTimeEpoch >= process.env.VUE_APP_ENDING_DATETIME_EPOCH;

  const isLive = hasStarted && !hasEnded;

  console.log(utcTimeEpoch, hasStarted, hasEnded, isLive);

  return { hasStarted, hasEnded, isLive };
};
